var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.857 0a5.143 5.143 0 00-4.92 6.634L0 12.571V16h3.429l5.937-5.937A5.142 5.142 0 0016 5.566a5.011 5.011 0 00-.943-3.429A5.143 5.143 0 0010.857 0zm0 9.143a4 4 0 01-1.143-.172l-.657-.2-.486.486-1.817 1.817-.805-.788-.806.805.788.789-.908.909L4.234 12l-.805.806.788.788-1.263 1.263H1.143v-1.811l5.6-5.617.486-.486-.166-.543a4.08 4.08 0 011.943-4.823 4 4 0 015.851 3.429 3.823 3.823 0 01-.623 2.285 4 4 0 01-3.377 1.852z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.428 5.714a1.143 1.143 0 100-2.285 1.143 1.143 0 000 2.285z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormKey);
export default __webpack_public_path__ + "static/media/form-key.db42c7382543cdc6575910827ceaed45.svg";
export { ForwardRef as ReactComponent };